import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLoading, getData, getFieldsData, getTypeList, getSubTypeList } from "../selectors";
import { RESET_STATE } from "../actionTypes";
import { getCatalogFieldsAction, getCatalogsAction, deleteTableAction, deleteFieldAction } from "../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString } from "@icarius-localization/strings";
import { openDialogAction } from "@icarius-common/dialog/actions";

const useCatalogs = () => {

  const [selectedRow, setSelectedRow] = useState(null);
  const [queryText, setQueryText] = useState("");
  const [selectedRowOptionList, setSelectedRowOptionList] = useState(null);
  const [enableTableDialogData, setEnableTableDialogData] = useState(null);
  const [createModifyTableDialogData, setCreateModifyTableDialogData] = useState(null);
  const [createModifyTableDialogIsOpen, setCreateModifyTableDialogIsOpen] = useState(null);
  const [createModifyFieldDialogData, setCreateModifyFieldDialogData] = useState(null);
  const [createModifyFieldDialogIsOpen, setCreateModifyFieldDialogIsOpen] = useState(null);
  const [modifyFieldOptionsDialogData, setmodifyFieldOptionsDialogData] = useState(null);
  const [modifyFieldOptionsDialogIsOpen, setmodifyFieldOptionsDialogIsOpen] = useState(null);

  const dispatch = useDispatch();

  const data = useSelector(getData);
  const isLoading = useSelector(getLoading);
  const fieldsData = useSelector(getFieldsData);
  const typeList = useSelector(getTypeList);
  const subTypeList = useSelector(getSubTypeList);

  useEffect(() => {
    dispatch(getCatalogsAction());
    return () => { dispatch({ type: RESET_STATE }) }
  }, [dispatch])

  const handleCatalogRowClick = (row) => {
    dispatch(getCatalogFieldsAction(row.data.code))
      .then(() => setSelectedRow(row.data))
  }

  const handleCatalogItemRowClick = (row) => {
    if (row.data?.optionList?.length) {
      setSelectedRowOptionList(row.data?.optionList);
    }
  }

  const handleCloseListDialog = () => {
    setSelectedRowOptionList(null);
  }

  const handleClearSelectedRow = () => {
    setSelectedRow(null);
  }

  const handleOpenEnableTableDialog = (gridRef) => {
    let selectedRows = gridRef.api.getSelectedRows();
    if (selectedRows.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
      return;
    }

    if (selectedRows[0].type !== "Del sistema") {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("onlySystemTablesCanHaveEditorsEnabledUserTablesAreAlreadyAutomaticallyEnabledForEditorCreation"),
        severity: "warning",
        duration: 10000,
      }));
      return;
    }

    setEnableTableDialogData(selectedRows[0])
  }

  const handleCloseEnableTableDialog = () => {
    setEnableTableDialogData(null);
  }

  const handleOpenModifyTableDialog = (gridRef) => {
    let selectedRows = gridRef.api.getSelectedRows();
    if (selectedRows.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
      return;
    }

    setCreateModifyTableDialogData(selectedRows[0]);
    setCreateModifyTableDialogIsOpen(true);
  }

  const handleOpenCreateTableDialog = () => {
    setCreateModifyTableDialogData(null);
    setCreateModifyTableDialogIsOpen(true);
  }

  const handleCloseCreateModifyTableDialog = () => {
    setCreateModifyTableDialogIsOpen(false);
    setCreateModifyTableDialogData(null);
  }


  const handleOpenDeleteTableDialog = (gridRef) => {
    let documents = gridRef.api.getSelectedRows();
    if (documents.length < 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRecord"), severity: "warning" }));
      return;
    }

    dispatch(openDialogAction({
      title: getLocalizedString("atention"),
      msg: getLocalizedString("tableDeleteConfirm").replace("{table}", documents[0].name),
      onConfirm: () => dispatch(openDialogAction({
        title: getLocalizedString("atention"),
        msg: getLocalizedString("tableDeleteSecondConfirm").replace("{table}", documents[0].name),
        onConfirm: () => dispatch(deleteTableAction({ code: documents[0].physicalCode })),
      })),
      acceptText: getLocalizedString("accept"),
      cancelText: getLocalizedString("cancel"),
    }));
  }

  const handleOpenModifyFieldDialog = (gridRef) => {
    let selectedRows = gridRef.api.getSelectedRows();
    if (selectedRows.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
      return;
    }

    setCreateModifyFieldDialogData(selectedRows[0]);
    setCreateModifyFieldDialogIsOpen(true);
  }

  const handleOpenCreateFieldDialog = () => {
    setCreateModifyFieldDialogData(null);
    setCreateModifyFieldDialogIsOpen(true);
  }

  const handleCloseCreateModifyFieldDialog = () => {
    setCreateModifyFieldDialogIsOpen(false);
    setCreateModifyFieldDialogData(null);
  }

  const handleOpenModifyFieldOptionsDialog = (gridRef) => {
    let selectedRows = gridRef.api.getSelectedRows();
    if (selectedRows.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
      return;
    }

    setmodifyFieldOptionsDialogData(selectedRows[0]);
    setmodifyFieldOptionsDialogIsOpen(true);
  }

  const handleCloseModifyFieldOptionsDialog = () => {
    setmodifyFieldOptionsDialogIsOpen(false);
    setmodifyFieldOptionsDialogData(null);
  }

  const handleOpenDeleteFieldDialog = (gridRef) => {
    let documents = gridRef.api.getSelectedRows();
    if (documents.length < 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRecord"), severity: "warning" }));
      return;
    }

    dispatch(openDialogAction({
      title: getLocalizedString("atention"),
      msg: getLocalizedString("fieldDeleteConfirm").replace("{field}", documents[0].name),
      onConfirm: () => dispatch(openDialogAction({
        title: getLocalizedString("atention"),
        msg: getLocalizedString("fieldDeleteSecondConfirm").replace("{field}", documents[0].name),
        onConfirm: () => dispatch(deleteFieldAction({ tableCode: documents[0].physicalCode, fieldCode: documents[0].fieldCode})),
      })),
      acceptText: getLocalizedString("accept"),
      cancelText: getLocalizedString("cancel"),
    }));
  }

  const handleOpenQueryDialog = (gridRef) => {
    let selectedRows = [];
    gridRef.api.forEachNodeAfterFilterAndSort((node) => node.selected && selectedRows.push(node.data));

    if (selectedRows.length < 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRecord"), severity: "warning" }));
      return;
    }

    let query = "SELECT";
    let dataTypes = "";


    selectedRows.forEach(element => {
      query += `\n\t"${element.fieldCode}" AS "${element.name}",`
      if (element.hasOptions === "Si") {
        dataTypes += "Lista,"

      } else {
        switch (element.type) {
          case "A":
          case "M":
            dataTypes += "Alfa,";
            break;
          case "D":
            dataTypes += "Fecha,";
            break;
          case "N":
            dataTypes += "Num,";
            break;
          case "B":
            dataTypes += "Mon,";
            break;
          default:
            break;
        }
      }
      dataTypes += ""
    });

    // Saco la coma extra
    query = query.slice(0, -1);

    // Agrego el from
    query += `\nFROM "${selectedRow.physicalCode}"`;

    // Saco la coma extra del dataTypes
    query += `\n\n${dataTypes.slice(0, -1)}`;

    setQueryText(query);
  }

  const handleCloseQueryDialog = () => {
    setQueryText("");
  }

  const state = {
    selectedRow,
    selectedRowOptionList,
    enableTableDialogData,
    createModifyTableDialogData,
    createModifyTableDialogIsOpen,
    queryText,
    createModifyFieldDialogData,
    createModifyFieldDialogIsOpen,
    modifyFieldOptionsDialogData,
    modifyFieldOptionsDialogIsOpen,
  };

  const handlers = {
    handleCatalogRowClick,
    handleCatalogItemRowClick,
    handleClearSelectedRow,
    handleCloseListDialog,
    handleOpenEnableTableDialog,
    handleCloseEnableTableDialog,
    handleOpenQueryDialog,
    handleCloseQueryDialog,
    handleCloseCreateModifyTableDialog,
    handleOpenModifyTableDialog,
    handleOpenCreateTableDialog,
    handleOpenDeleteTableDialog,
    handleCloseCreateModifyFieldDialog,
    handleOpenModifyFieldDialog,
    handleOpenCreateFieldDialog,
    handleOpenDeleteFieldDialog,
    handleOpenModifyFieldOptionsDialog,
    handleCloseModifyFieldOptionsDialog,
  };

  return {
    isLoading,
    data,
    fieldsData,
    state,
    handlers,
    typeList,
    subTypeList,
  }
}

export default useCatalogs;